import React, { useState } from 'react';
import { PlusCircle, Eye, EyeOff, Lock, Unlock, RefreshCw, Settings, AlertCircle, Trash2, Check } from 'lucide-react';
const VirtualCards = () => {
  const [showCardDetails, setShowCardDetails] = useState<{
    [key: string]: boolean;
  }>({
    'card-1': false,
    'card-2': false
  });
  const [isCreatingCard, setIsCreatingCard] = useState(false);
  const [cardCreated, setCardCreated] = useState(false);
  const [newCardData, setNewCardData] = useState({
    cardName: '',
    cardType: 'visa',
    fundingSource: 'usd-wallet',
    initialFunding: '',
    currency: 'USD'
  });
  const [cardLocked, setCardLocked] = useState({
    'card-1': false,
    'card-2': false
  });
  // Dummy card data for demonstration
  const cards = [{
    id: 'card-1',
    name: 'John Doe',
    number: '4111 2222 3333 4444',
    expiry: '12/25',
    cvv: '123',
    type: 'Virtual Card',
    brand: 'Visa',
    balance: 1250.75,
    currency: 'USD',
    status: 'active'
  }, {
    id: 'card-2',
    name: 'John Doe',
    number: '5555 6666 7777 8888',
    expiry: '10/24',
    cvv: '456',
    type: 'Virtual Card',
    brand: 'Mastercard',
    balance: 350.25,
    currency: 'USD',
    status: 'active'
  }];
  const toggleCardDetails = (cardId: string) => {
    setShowCardDetails(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };
  const toggleCardLock = (cardId: string) => {
    setCardLocked(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setNewCardData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCreateCard = (e: React.FormEvent) => {
    e.preventDefault();
    setIsCreatingCard(true);
    // Simulate API call
    setTimeout(() => {
      setIsCreatingCard(false);
      setCardCreated(true);
      // Reset form after showing success message
      setTimeout(() => {
        setCardCreated(false);
        setNewCardData({
          cardName: '',
          cardType: 'visa',
          fundingSource: 'usd-wallet',
          initialFunding: '',
          currency: 'USD'
        });
      }, 3000);
    }, 2000);
  };
  return <div className="py-6" data-id="element-713">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-714">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-715">Virtual Cards</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-716">
          Create and manage your virtual cards for online transactions
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8" data-id="element-717">
        <div className="mt-6" data-id="element-718">
          <div className="flex justify-between items-center mb-6" data-id="element-719">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-720">
              Your Virtual Cards
            </h2>
            <button type="button" onClick={() => window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
          })} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-721">
              <PlusCircle className="h-5 w-5 mr-2" data-id="element-722" />
              Create New Card
            </button>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-723">
            {cards.map(card => <div key={card.id} className="bg-white overflow-hidden shadow rounded-lg" data-id="element-724">
                <div className="p-6" data-id="element-725">
                  <div className={`rounded-lg p-6 ${cardLocked[card.id] ? 'bg-gray-500' : card.brand === 'Visa' ? 'bg-gradient-to-r from-blue-500 to-blue-700' : 'bg-gradient-to-r from-red-500 to-red-700'} text-white mb-4 relative`} data-id="element-726">
                    {cardLocked[card.id] && <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center" data-id="element-727">
                        <Lock className="h-12 w-12 text-white opacity-80" data-id="element-728" />
                      </div>}
                    <div className="flex justify-between items-start" data-id="element-729">
                      <div data-id="element-730">
                        <p className="text-xs font-medium opacity-80" data-id="element-731">
                          VIRTUAL CARD
                        </p>
                        <p className="text-sm mt-1" data-id="element-732">{card.type}</p>
                      </div>
                      <div className="text-right" data-id="element-733">
                        <p className="text-xs font-medium opacity-80" data-id="element-734">
                          {card.brand}
                        </p>
                        <p className="text-sm mt-1" data-id="element-735">USD</p>
                      </div>
                    </div>
                    <div className="mt-6" data-id="element-736">
                      <p className="text-xs font-medium opacity-80" data-id="element-737">
                        CARD NUMBER
                      </p>
                      <p className="text-base mt-1 tracking-wider" data-id="element-738">
                        {showCardDetails[card.id] && !cardLocked[card.id] ? card.number : '•••• •••• •••• ' + card.number.slice(-4)}
                      </p>
                    </div>
                    <div className="mt-4 flex justify-between" data-id="element-739">
                      <div data-id="element-740">
                        <p className="text-xs font-medium opacity-80" data-id="element-741">
                          CARD HOLDER
                        </p>
                        <p className="text-sm mt-1" data-id="element-742">{card.name}</p>
                      </div>
                      <div className="text-right" data-id="element-743">
                        <p className="text-xs font-medium opacity-80" data-id="element-744">
                          EXPIRES
                        </p>
                        <p className="text-sm mt-1" data-id="element-745">
                          {showCardDetails[card.id] && !cardLocked[card.id] ? card.expiry : '••/••'}
                        </p>
                      </div>
                      <div className="text-right" data-id="element-746">
                        <p className="text-xs font-medium opacity-80" data-id="element-747">CVV</p>
                        <p className="text-sm mt-1" data-id="element-748">
                          {showCardDetails[card.id] && !cardLocked[card.id] ? card.cvv : '•••'}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-749">
                    <div data-id="element-750">
                      <p className="text-sm text-gray-500" data-id="element-751">Available Balance</p>
                      <p className="text-xl font-semibold text-gray-900" data-id="element-752">
                        ${card.balance.toFixed(2)}
                      </p>
                    </div>
                    <div className="flex space-x-2" data-id="element-753">
                      <button onClick={() => toggleCardDetails(card.id)} disabled={cardLocked[card.id]} className={`inline-flex items-center px-3 py-1.5 border shadow-sm text-sm font-medium rounded-md ${cardLocked[card.id] ? 'bg-gray-100 text-gray-400 border-gray-200' : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`} data-id="element-754">
                        {showCardDetails[card.id] ? <>
                            <EyeOff className="h-4 w-4 mr-1" data-id="element-755" /> Hide
                          </> : <>
                            <Eye className="h-4 w-4 mr-1" data-id="element-756" /> Show
                          </>}
                      </button>
                      <button onClick={() => toggleCardLock(card.id)} className={`inline-flex items-center px-3 py-1.5 border shadow-sm text-sm font-medium rounded-md ${cardLocked[card.id] ? 'text-green-700 border-green-300 bg-green-50 hover:bg-green-100' : 'text-red-700 border-red-300 bg-red-50 hover:bg-red-100'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`} data-id="element-757">
                        {cardLocked[card.id] ? <>
                            <Unlock className="h-4 w-4 mr-1" data-id="element-758" /> Unlock
                          </> : <>
                            <Lock className="h-4 w-4 mr-1" data-id="element-759" /> Lock
                          </>}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="border-t border-gray-200 bg-gray-50 px-6 py-4" data-id="element-760">
                  <div className="grid grid-cols-4 gap-4" data-id="element-761">
                    <button className="flex flex-col items-center justify-center text-sm text-blue-600 hover:text-blue-800" data-id="element-762">
                      <RefreshCw className="h-5 w-5" data-id="element-763" />
                      <span className="mt-1" data-id="element-764">Fund</span>
                    </button>
                    <button className="flex flex-col items-center justify-center text-sm text-blue-600 hover:text-blue-800" data-id="element-765">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-766">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-767" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" data-id="element-768" />
                      </svg>
                      <span className="mt-1" data-id="element-769">Transactions</span>
                    </button>
                    <button className="flex flex-col items-center justify-center text-sm text-blue-600 hover:text-blue-800" data-id="element-770">
                      <Settings className="h-5 w-5" data-id="element-771" />
                      <span className="mt-1" data-id="element-772">Settings</span>
                    </button>
                    <button className="flex flex-col items-center justify-center text-sm text-red-600 hover:text-red-800" data-id="element-773">
                      <Trash2 className="h-5 w-5" data-id="element-774" />
                      <span className="mt-1" data-id="element-775">Delete</span>
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
          {/* Card Usage Stats */}
          <div className="mt-10 bg-white shadow rounded-lg overflow-hidden" data-id="element-776">
            <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-777">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-778">
                Card Usage Statistics
              </h3>
            </div>
            <div className="px-4 py-5 sm:p-6" data-id="element-779">
              <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-780">
                <div className="bg-gray-50 overflow-hidden shadow-sm rounded-lg" data-id="element-781">
                  <div className="p-5" data-id="element-782">
                    <div className="flex items-center" data-id="element-783">
                      <div className="flex-shrink-0" data-id="element-784">
                        <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-785">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2z" data-id="element-786" />
                        </svg>
                      </div>
                      <div className="ml-5 w-0 flex-1" data-id="element-787">
                        <dl data-id="element-788">
                          <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-789">
                            Total Spent This Month
                          </dt>
                          <dd data-id="element-790">
                            <div className="text-lg font-medium text-gray-900" data-id="element-791">
                              $1,245.89
                            </div>
                          </dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 overflow-hidden shadow-sm rounded-lg" data-id="element-792">
                  <div className="p-5" data-id="element-793">
                    <div className="flex items-center" data-id="element-794">
                      <div className="flex-shrink-0" data-id="element-795">
                        <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-796">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" data-id="element-797" />
                        </svg>
                      </div>
                      <div className="ml-5 w-0 flex-1" data-id="element-798">
                        <dl data-id="element-799">
                          <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-800">
                            Total Transactions
                          </dt>
                          <dd data-id="element-801">
                            <div className="text-lg font-medium text-gray-900" data-id="element-802">
                              32
                            </div>
                          </dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 overflow-hidden shadow-sm rounded-lg" data-id="element-803">
                  <div className="p-5" data-id="element-804">
                    <div className="flex items-center" data-id="element-805">
                      <div className="flex-shrink-0" data-id="element-806">
                        <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-807">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-808" />
                        </svg>
                      </div>
                      <div className="ml-5 w-0 flex-1" data-id="element-809">
                        <dl data-id="element-810">
                          <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-811">
                            Last Transaction
                          </dt>
                          <dd data-id="element-812">
                            <div className="text-lg font-medium text-gray-900" data-id="element-813">
                              2 days ago
                            </div>
                          </dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Card Creation Form */}
          <div className="mt-10" id="create-card-section" data-id="element-814">
            <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-815">
              Create a New Virtual Card
            </h2>
            {cardCreated ? <div className="bg-green-50 border-l-4 border-green-400 p-4 mb-6" data-id="element-816">
                <div className="flex" data-id="element-817">
                  <div className="flex-shrink-0" data-id="element-818">
                    <Check className="h-5 w-5 text-green-400" data-id="element-819" />
                  </div>
                  <div className="ml-3" data-id="element-820">
                    <p className="text-sm text-green-700" data-id="element-821">
                      Your virtual card has been created successfully! It will
                      appear in your cards list shortly.
                    </p>
                  </div>
                </div>
              </div> : <div className="bg-white shadow sm:rounded-lg" data-id="element-822">
                <div className="px-4 py-5 sm:p-6" data-id="element-823">
                  <form onSubmit={handleCreateCard} data-id="element-824">
                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-825">
                      <div data-id="element-826">
                        <label htmlFor="cardName" className="block text-sm font-medium text-gray-700" data-id="element-827">
                          Card Name
                        </label>
                        <div className="mt-1" data-id="element-828">
                          <input type="text" name="cardName" id="cardName" value={newCardData.cardName} onChange={handleInputChange} className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Shopping Card" required data-id="element-829" />
                        </div>
                      </div>
                      <div data-id="element-830">
                        <label htmlFor="cardType" className="block text-sm font-medium text-gray-700" data-id="element-831">
                          Card Type
                        </label>
                        <select id="cardType" name="cardType" value={newCardData.cardType} onChange={handleInputChange} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-832">
                          <option value="visa" data-id="element-833">Visa Virtual Card</option>
                          <option value="mastercard" data-id="element-834">
                            Mastercard Virtual Card
                          </option>
                        </select>
                      </div>
                      <div data-id="element-835">
                        <label htmlFor="fundingSource" className="block text-sm font-medium text-gray-700" data-id="element-836">
                          Funding Source
                        </label>
                        <select id="fundingSource" name="fundingSource" value={newCardData.fundingSource} onChange={handleInputChange} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-837">
                          <option value="usd-wallet" data-id="element-838">
                            USD Wallet ($2,540.50)
                          </option>
                          <option value="gbp-wallet" data-id="element-839">
                            GBP Wallet (£1,250.75)
                          </option>
                        </select>
                      </div>
                      <div data-id="element-840">
                        <label htmlFor="initialFunding" className="block text-sm font-medium text-gray-700" data-id="element-841">
                          Initial Funding Amount
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm" data-id="element-842">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-843">
                            <span className="text-gray-500 sm:text-sm" data-id="element-844">$</span>
                          </div>
                          <input type="text" name="initialFunding" id="initialFunding" value={newCardData.initialFunding} onChange={handleInputChange} className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" required data-id="element-845" />
                          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-846">
                            <span className="text-gray-500 sm:text-sm" data-id="element-847">
                              USD
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-6" data-id="element-848">
                      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4" data-id="element-849">
                        <div className="flex" data-id="element-850">
                          <div className="flex-shrink-0" data-id="element-851">
                            <AlertCircle className="h-5 w-5 text-yellow-400" data-id="element-852" />
                          </div>
                          <div className="ml-3" data-id="element-853">
                            <p className="text-sm text-yellow-700" data-id="element-854">
                              Virtual cards are subject to a $2.00 creation fee.
                              Your card will be active immediately after
                              creation.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-6" data-id="element-855">
                      <button type="submit" disabled={isCreatingCard} className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white ${isCreatingCard ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`} data-id="element-856">
                        {isCreatingCard ? <>
                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-857">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-858"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-859"></path>
                            </svg>
                            Creating Card...
                          </> : 'Create Virtual Card'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};
export default VirtualCards;